import React from "react";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import useExternalPriceTaxDisclaimer from "../../../../hooks/shared/useExternalPriceTaxDisclaimer";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import * as BasketList from "../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/BasketList";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import SrOnly from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/ScreenreaderOnly";
import PricePromoIcon from "./PricePromoIcon";
import { PromotionTypeEnum } from "../../../../../../../common-deprecated/types/CommonTypes";
import { useBnbSelector } from "../../../../redux/store";

const ExternalPriceTaxDisclaimer = (): JSX.Element | null => {
    const {
        visible,
        fullTaxLabel,
        co2TaxLabels,
        formattedTax,
        showCo2Disclaimer,
        formattedValueBeforeTax,
        showValueBeforeTax,
    } = useExternalPriceTaxDisclaimer();

    const { promotions } = useBnbSelector((state) => state.items);

    const [basketTaxDisclaimerContent, basketTaxDisclaimerTitle] = useBnbOptionalLabel([
        "basketTaxDisclaimerContent",
        "basketTaxDisclaimerTitle",
    ]);

    if (!visible) return null;
    return (
        <BasketList.BasketList mt={2}>
            {showValueBeforeTax && (
                <BasketList.BasketListItem>
                    <BasketList.ListItemLabel>
                        <Type.SmallText>
                            <BnbLabel label="basketTotalValueBeforeTax" />
                        </Type.SmallText>
                    </BasketList.ListItemLabel>
                    <BasketList.ListItemValue>
                        <Type.SmallText>
                            <span dangerouslySetInnerHTML={{ __html: formattedValueBeforeTax }} />
                        </Type.SmallText>
                    </BasketList.ListItemValue>
                </BasketList.BasketListItem>
            )}
            <BasketList.BasketListItem>
                <BasketList.ListItemLabel>
                    {co2TaxLabels ? (
                        <Type.SmallText>
                            {co2TaxLabels.start}
                            {co2TaxLabels.value}
                            &nbsp;
                            <Button.Link
                                onClick={(event) => {
                                    event.preventDefault();
                                    showCo2Disclaimer();
                                }}
                            >
                                <IconWrapper>
                                    <Icon variant="info" />
                                </IconWrapper>
                                <SrOnly>
                                    <BnbLabel label="bnbA11yButtonMoreInfo" />
                                </SrOnly>
                            </Button.Link>
                            {co2TaxLabels.end}
                        </Type.SmallText>
                    ) : (
                        <Type.SmallText>{fullTaxLabel}</Type.SmallText>
                    )}
                </BasketList.ListItemLabel>
                <BasketList.ListItemValue>
                    <Type.SmallHeading>
                        <span dangerouslySetInnerHTML={{ __html: formattedTax }} />
                    </Type.SmallHeading>
                </BasketList.ListItemValue>
                {basketTaxDisclaimerContent && basketTaxDisclaimerTitle && (
                    <PricePromoIcon
                        promotions={[
                            {
                                amount: Number(formattedTax.match(/^\d+/) ? [0] : 0),
                                description: basketTaxDisclaimerContent,
                                id: `${basketTaxDisclaimerTitle}-${promotions.length + 1}`,
                                index: promotions.length + 1,
                                name: basketTaxDisclaimerTitle,
                                type: PromotionTypeEnum.None,
                            },
                        ]}
                    />
                )}
            </BasketList.BasketListItem>
        </BasketList.BasketList>
    );
};

export default ExternalPriceTaxDisclaimer;
